import { Table } from 'dexie';
import db, { DataRepository, Database, Key } from '@/db';
import { PlayerRegionLookup } from '../../api/models';

export type TABLE_TYPE = Table<PlayerRegionLookup>;

export const TABLE = 'playerRegionLookups';
const SCHEMA = 'playerRegionLookupId, sortId';

class PlayerRegionLookupsDatabase implements DataRepository<PlayerRegionLookup> {
  constructor(private db: Database) {
    db.registerModelSchema(TABLE, SCHEMA);
  }

  get(key: Key): Promise<PlayerRegionLookup | undefined> {
    return this.db[TABLE].get(key);
  }

  delete(key: Key): Promise<void> {
    return this.db[TABLE].delete(key);
  }

  update(payload: PlayerRegionLookup, key: Key): Promise<PlayerRegionLookup> {
    return this.db[TABLE].put(payload, key);
  }

  async bulkAdd(payload: PlayerRegionLookup[]): Promise<PlayerRegionLookup[]> {
    await this.db[TABLE].clear();
    return this.db[TABLE].bulkPut(payload);
  }

  list(): Promise<PlayerRegionLookup[]> {
    return this.db[TABLE].orderBy('sortId').toArray();
  }
}

export const PlayerRegionLookupsDB = new PlayerRegionLookupsDatabase(db);
